























import {Component, Prop, Vue} from 'vue-property-decorator';
import {ExhibitorInfo} from '@/script/ExhibitorManager';

@Component
export default class Exhibitor extends Vue {
  @Prop({ type: Object, required: true })
  private entrant!: ExhibitorInfo;

  private openTwitter() {
    window.open(this.entrant.twitterUrl, '_blank');
  }

  private openPage() {
    window.open(this.entrant.pageUrl, '_blank');
  }
}
